(function () {
  "use strict";

  var root = document.querySelector("[data-rems-request-planner]");
  if (!root) return;

  var select = root.querySelector("[data-request-category]");
  var source = root.querySelector("[data-request-source]");
  var title = root.querySelector("[data-request-title]");
  var options = Array.prototype.slice.call(root.querySelectorAll("[data-request-option]"));
  var allowed = options.map(function (button) { return button.dataset.requestOption; });

  function selectCategory(value) {
    if (!allowed.includes(value)) value = "something-else";
    if (select) select.value = value;
    if (source) source.value = value;
    options.forEach(function (button) {
      button.setAttribute("aria-pressed", String(button.dataset.requestOption === value));
    });
    var active = options.find(function (button) { return button.dataset.requestOption === value; });
    if (title && active) title.textContent = active.dataset.requestHeading || "Tell us what you need made.";
  }

  options.forEach(function (button) {
    button.addEventListener("click", function () {
      selectCategory(button.dataset.requestOption);
      select?.focus();
    });
  });
  select?.addEventListener("change", function () { selectCategory(select.value); });

  var requested = new URLSearchParams(window.location.search).get("request") || "something-else";
  selectCategory(requested);
})();
